module.exports = __webpack_public_path__ + "img/ui-credit-card-priorities.038750f7.png";